import { Routes } from '@angular/router';
import { authRoutes } from '@auth/app/auth.routes';

export const routes: Routes = [
  ...authRoutes,
  {
    path: 'issuer',
    loadChildren: () => import('@issuer/app/issuer.routes').then((m) => m.issuerRoutes),
  },
  {
    path: 'eqauth',
    loadChildren: () => import('@auth-admin/app/auth-admin.routes').then((m) => m.authAdminRoutes),
  },
  {
    path: 'pagamentos',
    loadChildren: () => import('@payments/app/payments.routes').then((m) => m.paymentsRoutes),
  },
  { path: '', pathMatch: 'full', redirectTo: 'issuer' },
  { path: '**', redirectTo: 'issuer' },
];
